import React from 'react';
import FixedNav from "../components/Nav/FixedNav";
import MobileNav from "../components/Nav/MobileNav";
import Header from "../components/Description/Header";
import Title from "../components/Description/Title";
import Normal from "../components/Description/Normal";
import Big from "../components/Description/Big";
import Footer from "../components/Footer";

const ContestRules = () => {
  return (
    <div id="body">
      <div className="framer-IqNBt framer-vrYYp framer-NrkXy framer-l50WH framer-V74Ls framer-uKIIJ framer-Fw2Wf framer-72rtr7 min-h-screen !w-auto">
        <FixedNav />
        <MobileNav />
        <div id="content" className="w-full mt-[60px] p-[20px]">
          <Header>CodeBlaze AI Twitter Contest Rules</Header>
          <Normal>
            Welcome to the CodeBlaze AI Twitter Contest! Follow the rules below for a chance to win 3 months of free credit. Good luck!
          </Normal>
          <div className="p-10" />
          
          <Title>1. Eligibility</Title>
          <div className="p-5" />
          <Normal>
            - The contest is open to individuals who are at least 18 years old at the time of entry.
            <br />
            - Employees of CodeBlaze, their immediate family members, and anyone involved in the organization or judging of the contest are not eligible to participate.
            <br />
            - Participants must have a valid Twitter account and agree to receive communications from CodeBlaze.
          </Normal>
          <div className="p-5" />
          
          <Title>2. Contest Period</Title>
          <div className="p-5" />
          <Normal>
            - The contest begins on March 1, 2025, and ends on March 30, 2025. All entries must be submitted within this period.
            <br />
            - CodeBlaze reserves the right to extend or shorten the contest period at its discretion.
          </Normal>
          <div className="p-5" />
          
          <Title>3. How to Enter</Title>
          <div className="p-5" />
          <Big>To enter the contest, participants must:</Big>
          <div className="p-3" />
          <Normal>
            - <strong>Like</strong> the contest tweet posted by @CodeBlazeAI.
            <br />
            - <strong>Retweet</strong> the contest tweet with the hashtag #CodeBlazeContest.
            <br />
            - <strong>Comment</strong> on the contest tweet, mentioning why you want to win 3 months of free credit.
          </Normal>
          <div className="p-3" />
          <Normal>
            - Each participant may submit only one entry. Multiple entries from the same participant will be disqualified.
          </Normal>
          <div className="p-5" />
          
          <Title>4. Winner Selection</Title>
          <div className="p-5" />
          <Normal>
            - Winners will be selected randomly from all eligible entries.
            <br />
            - The winners will be announced on April 1, 2025, on the CodeBlaze Twitter account and website.
          </Normal>
          <div className="p-5" />
          
          <Title>5. Prizes</Title>
          <div className="p-5" />
          <Normal>
            - The prize consists of 3 months of free credit for CodeBlaze AI services.
            <br />
            - Prizes are non-transferable and cannot be exchanged for cash.
          </Normal>
          <div className="p-5" />
          
          <Title>6. Intellectual Property</Title>
          <div className="p-5" />
          <Normal>
            - By participating in the contest, entrants grant CodeBlaze a non-exclusive, royalty-free license to use, display, and promote their comments for marketing and promotional purposes.
          </Normal>
          <div className="p-5" />
          
          <Title>7. Disqualification</Title>
          <div className="p-5" />
          <Big>CodeBlaze reserves the right to disqualify any entry that:</Big>
          <div className="p-3" />
          <Normal>
            - Violates the contest rules or any applicable laws.
            <br />
            - Contains offensive, inappropriate, or discriminatory content.
            <br />
            - Is deemed to be spam or not original.
          </Normal>
          <div className="p-5" />
          
          <Title>8. Liability</Title>
          <div className="p-5" />
          <Normal>
            - CodeBlaze is not responsible for any technical issues, errors, or delays that may affect the submission or judging of entries.
            <br />
            - Participants agree to release and hold harmless CodeBlaze from any liability, loss, or damage arising from participation in the contest or acceptance of prizes.
          </Normal>
          <div className="p-5" />
          
          <Title>9. Privacy</Title>
          <div className="p-5" />
          <Normal>
            - Personal information collected from participants will be used solely for the purposes of the contest and will not be shared with third parties without consent.
            <br />
            - By entering the contest, participants agree to receive communications from CodeBlaze related to the contest and future events.
          </Normal>
          <div className="p-5" />
          
          <Title>10. General</Title>
          <div className="p-5" />
          <Normal>
            - CodeBlaze reserves the right to modify, suspend, or terminate the contest at any time without prior notice.
            <br />
            - Any disputes related to the contest will be resolved in accordance with the laws of Delaware, USA.
            <br />
            - By participating in the contest, entrants agree to be bound by these rules and the decisions of the judges, which are final and binding.
          </Normal>
          <div className="p-7" />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ContestRules;
